import React, { useMemo } from 'react';
import { useGetTSPsQuery } from '../services/edgeApi';
import { useDispatch, useSelector } from 'react-redux';
import { selectTspOptions } from '../map/slice/mapSelectors';
import { selectAdvancedNoticeComponentFilters } from '../filters/advancedFiltersSelectors';
import { MultiSelectButton, MultiSelectSearch } from '../helpers/MultiSelect';
import {
  advancedFiltersActions,
  AdvancedFiltersState,
} from '../filters/advancedFiltersSlice';
import { CAPACITY_TYPE_OPTIONS } from '../capacityComponents/capacityTypeOptions';

export const NoticeComponentFilters: React.FC = () => {
  useGetTSPsQuery(undefined);
  const dispatch = useDispatch();

  const tspOptions = useSelector(selectTspOptions);
  const noticeComponentFilters = useSelector(
    selectAdvancedNoticeComponentFilters,
  );

  const options = useMemo<
    {
      id: string;
      field: keyof AdvancedFiltersState['noticeComponents'];
      value: boolean;
      name: string;
    }[]
  >(
    () => [
      {
        id: 'mapped=true',
        field: 'mapped',
        value: true,
        name: 'Mapped',
      },
      {
        id: 'mapped=false',
        field: 'mapped',
        value: false,
        name: 'Unmapped',
      },
      {
        id: 'hasPoints=true',
        field: 'hasPoints',
        value: true,
        name: 'Has Points',
      },
      {
        id: 'hasPoints=false',
        field: 'hasPoints',
        value: false,
        name: 'No Points',
      },
      {
        id: 'hasCapacityComponent=true',
        field: 'hasCapacityComponent',
        value: true,
        name: 'Has Capacity Component',
      },
      {
        id: 'hasCapacityComponent=false',
        field: 'hasCapacityComponent',
        value: false,
        name: 'No Capacity Component',
      },
      {
        id: 'hasNoticeActivity=true',
        field: 'hasNoticeActivity',
        value: true,
        name: 'Has Notice Activity',
      },
      {
        id: 'hasNoticeActivity=false',
        field: 'hasNoticeActivity',
        value: false,
        name: 'No Notice Activity',
      },
    ],
    [],
  );

  return (
    <div className="my-2 p-3">
      <div className="row">
        <div className="col">
          <MultiSelectButton
            title="Conditions"
            options={options}
            markedFirst={false}
            keyExtractor={(option) => option.id}
            isMarked={({ field, value }) => {
              return noticeComponentFilters[field] === value;
            }}
            onToggle={(option, isMarked) => {
              const { field, value } = option;
              const filterValue = isMarked ? value : null;
              dispatch(
                advancedFiltersActions.setFilterValue({
                  type: 'noticeComponents',
                  field,
                  value: filterValue,
                }),
              );
            }}
            optionRenderer={(option) => option.name}
          />
        </div>
        <div className="col">
          <input
            className="form-control"
            placeholder="Search"
            value={noticeComponentFilters.textSearch ?? undefined}
            onChange={(evt) =>
              dispatch(
                advancedFiltersActions.setFilterValue({
                  type: 'noticeComponents',
                  field: 'textSearch',
                  value: evt.target.value,
                }),
              )
            }
          />
        </div>
        <div className="col">
          <MultiSelectSearch
            placeholder="TSP"
            options={tspOptions}
            value={noticeComponentFilters.tsps}
            onChange={(options) => {
              dispatch(
                advancedFiltersActions.setFilterValue({
                  type: 'noticeComponents',
                  field: 'tsps',
                  value: options.map((option) => option.value),
                }),
              );
            }}
          />
        </div>
        <div className="col">
          <MultiSelectSearch
            placeholder="Capacity Type"
            options={CAPACITY_TYPE_OPTIONS}
            value={noticeComponentFilters.capacityTypes}
            onChange={(options) => {
              dispatch(
                advancedFiltersActions.setFilterValue({
                  type: 'noticeComponents',
                  field: 'capacityTypes',
                  value: options.map((option) => option.value),
                }),
              );
            }}
          />
        </div>
      </div>
    </div>
  );
};
